var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-header"},[_c('div',{staticClass:"nav2"},[_c('ul',_vm._l((_vm.menu),function(item,index){return _c('li',{key:index,class:{
          active: _vm.$route.name == item.path,
        },on:{"click":function($event){return _vm.goMenu(item.id, item.path)}}},[_c('i',{class:[item.icon]}),_c('span',[_vm._v(_vm._s(item.value))])])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }